export default "__VITE_ASSET__b30556e8__"